module.exports = __webpack_public_path__ + "img/resource-zj-active.0f67d99d.png";